var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 10.3008C0.664062 4.77793 5.14121 0.300781 10.6641 0.300781H38.6641C44.1869 0.300781 48.6641 4.77793 48.6641 10.3008V38.3008C48.6641 43.8236 44.1869 48.3008 38.6641 48.3008H10.6641C5.14121 48.3008 0.664062 43.8236 0.664062 38.3008V10.3008Z",
    fill: "url(#paint0_linear_4168_6009)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6641 32.3008V16.3008C28.6641 15.7703 28.4533 15.2616 28.0783 14.8866C27.7032 14.5115 27.1945 14.3008 26.6641 14.3008H22.6641C22.1336 14.3008 21.6249 14.5115 21.2498 14.8866C20.8748 15.2616 20.6641 15.7703 20.6641 16.3008V32.3008",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6641 18.3008H16.6641C15.5595 18.3008 14.6641 19.1962 14.6641 20.3008V30.3008C14.6641 31.4054 15.5595 32.3008 16.6641 32.3008H32.6641C33.7686 32.3008 34.6641 31.4054 34.6641 30.3008V20.3008C34.6641 19.1962 33.7686 18.3008 32.6641 18.3008Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_6009",
    x1: 24.6641,
    y1: 0.300781,
    x2: 24.6641,
    y2: 48.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/Private.746a49d7a6f777a09fe82b18402414bc.svg";
export { ForwardRef as ReactComponent };